import { platformBrowserDynamic }   from '@angular/platform-browser-dynamic';
import { StaticProvider }                 from '@angular/core';
//import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';
import { enableProdMode }           from '@angular/core';
import { getTranslationProviders }  from './app/i18n-providers';

import { AppModule } from './app/app.module';

enableProdMode();

getTranslationProviders().then((providers:StaticProvider[]) => {
  const options = { providers };
  platformBrowserDynamic(providers).bootstrapModule(AppModule, options);
});

//function fetchLocale() {
//  const locale = 'en';
//  const noProviders: Object[] = [];
//
//  const translationFile = `locale/messages.${locale}.xlf`;
//  return window['fetch'](translationFile)
//    .then(resp => resp.text())
//    .then( (translations: string ) => [
//      { provide: TRANSLATIONS, useValue: translations },
//      { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
//      { provide: LOCALE_ID, useValue: locale }
//    ])
//    .catch(() => noProviders);
//}
//
//fetchLocale().then(providers => {
//  const options = { providers };
//  platformBrowserDynamic(<Provider[]>options.providers).bootstrapModule(AppModule, options);
//});
